const registerShopEN = {
	step: "Step {{step}} of 3",

	step1: {
		title: "Create Admin Account",
		firstName: "First name",
		lastName: "Last name",
		phone: "Phone number",
		password: "Password",
		confirmPassword: "Confirm Password",
		upload:"Upload",
		remember: "Remember me",
		register: "Register",
		registering: "Registering...",
		referralCode: "Referral Code"
	},

	errors: {
		fillRequired: "Please fill in all required fields.",
		passwordMatch: "Passwords do not match.",
		uploadImages: "Please upload at least one photo before finishing setup.",
		invalidInvite: "Invalid or expired invite link.",
	},

	success: {
		adminCreated: "Admin created successfully — now set up your shop.",
		returning: "Welcome back! Continue registering your shop.",
	},

	days: {
		Monday: "Monday",
		Tuesday: "Tuesday",
		Wednesday: "Wednesday",
		Thursday: "Thursday",
		Friday: "Friday",
		Saturday: "Saturday",
		Sunday: "Sunday",
	},
};

export default registerShopEN;
